import { useParams } from 'react-router-dom';
import { createContext } from 'react';

import useMasterService from '../hooks/useMasterService';

export const MasterServiceContext = createContext(null);

export default function MasterServiceProvider({ children }) {
  const { masterServiceId } = useParams();

  const { data: masterService, isLoading: isMasterServiceLoading } =
    useMasterService(masterServiceId);

  return (
    <MasterServiceContext.Provider value={{ masterService, isMasterServiceLoading }}>
      {children}
    </MasterServiceContext.Provider>
  );
}
